/**
 * Application-wide branding constants.
 *
 * Change these values to rebrand the entire application.
 * All UI templates and components reference these constants.
 */
export const APP_NAME = 'MySportApp';
export const COMPANY_NAME = 'MySportApp';
export const SUPPORT_EMAIL = 'notificaciones@mysportapp.co';
